import React from 'react';
import CompanyContainer from './CompanyContainer.component';

const Company = ({companies}) => (
    <div className="company-list">
          <CompanyContainer companies={companies} />
    </div>
);

export default Company;